// Owner: scheduling (owner feedback F13). Command bar (⌘K): "Book a meeting", the Meetings page, meeting types
// and working hours. Loaded with the shell, so this file stays tiny; the items and their messages load on
// the first search.
import { defineAppCommands } from '../../extensions/commands';
import { moduleOn } from '../../lib/modules';

export default defineAppCommands({
  id: 'scheduling',
  providers: [
    {
      id: 'scheduling.go',
      items: async (query) => {
        // An optional workspace module: nothing while Meetings is off.
        if (!moduleOn('meetings')) return [];
        const { meetingCommandItems } = await import('./command-items');
        return meetingCommandItems(query);
      },
    },
  ],
});
